import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { LuBookMarked, LuBookOpen } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export const SubmenuTahfidzPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Lembaga Tahfidz" });
  }, [setHeader]);

  return (
    <div className="tw-px-4 tw-pt-4 tw-pb-20">
      <div className="tw-px-0 card-body">
        <div className="card-body-grid">
          <div className="card-grid">
            <div onClick={() => navigate(linkPage.HOME_PROFILE)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#e0f9f2]">
                <LuBookOpen className="tw-text-2xl tw-text-[#0d9488]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Tazmi Juz'iyah</div>
            </div>
          </div>

          <div className="card-grid">
            <div onClick={() => navigate(linkPage.FINANCE_BILLING_INFO)} className="tw-m-0">
              <div className="tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-2 tw-rounded-2xl tw-w-[44px] tw-h-[44px] tw-bg-[#e4e8ff]">
                <LuBookMarked className="tw-text-2xl tw-text-[#6366f1]" />
              </div>
              <div className="tw-line-clamp-1 card-name">Ziyadah Santri</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
